webpackJsonp([27],{

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(13);

var _underscore2 = _interopRequireDefault(_underscore);

var _Mustache = __webpack_require__(37);

var _Mustache2 = _interopRequireDefault(_Mustache);

var _dataLayer = __webpack_require__(53);

var _dataLayer2 = _interopRequireDefault(_dataLayer);

var _Rover = __webpack_require__(3);

var _Rover2 = _interopRequireDefault(_Rover);

var _rover_modal = __webpack_require__(90);

var _rover_modal2 = _interopRequireDefault(_rover_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A photo gallery modal built using a royal slider(http://dimsemenov.com/plugins/royal-slider/documentation/)
 * inside of a chromeless Bootstrap modal (see .rover-media-modal)
 *
 * Example usage:
 *
 * import GalleryModalView from 'gallery_modal';
 *
 * const gallery = new GalleryModalView({
 *     slides: [
 *         { type: "image", src: "something.jpg", caption: "A photo of something" },
 *         { type: "image", src: "something2.jpg", caption: "Another photo of something" }
 *     ]
 * });
 *
 * // Open the gallery
 * gallery.open();
 *
 * // Open the gallery to 5th slide
 * gallery.openTo(4)
 *
 */
exports.default = _rover_modal2.default.extend({
  slideTemplates: {
    image: _Mustache2.default.template('new_design/common/media_gallery/image'),
    video: _Mustache2.default.template('new_design/common/media_gallery/video')
  },
  defaults: {
    classes: '',
    slides: []
  },
  initialize: function initialize(options) {
    this.options = _underscore2.default.extend({}, this.defaults, options);
    this.options.classes += ' rover-media-modal';
    // Since this modal is full-screen, we don't want scrollfixes
    this.options.applyScrollFix = false;
    _rover_modal2.default.prototype.initialize.call(this, this.options);
  },
  render: function render() {
    _rover_modal2.default.prototype.render.call(this);
    this.$modalContent.addClass('rover-media-gallery royalSlider');

    // Build up gallery markup
    var markup = this.getGalleryMarkup(this.options.slides);

    // Inject markup into modal
    this.setContent(markup);

    // Instantiate slider
    this.royalSlider = this.$modalContent.royalSlider({
      autoScaleSlider: false,
      controlNavigation: 'none',
      globalCaption: true,
      keyboardNavEnabled: true,
      numImagesToPreload: 2
    }).data('royalSlider');

    if (this.royalSlider) {
      this.initVideoSupport();
    }
  },

  // Adapted from http://help.dimsemenov.com/kb/royalslider-javascript-api/adding-support-for-third-party-video-player
  initVideoSupport: function initVideoSupport() {
    var _this = this;

    var slider = this.royalSlider;
    var videoPlayer = void 0;

    slider.ev.on('rsOnCreateVideoElement', function (e, videoSrc) {
      slider.videoObj = (0, _jquery2.default)('<div class="rsVideoObj"></div>');
      _underscore2.default.defer(function () {
        var currSlide = e.target.currSlide;
        var h = currSlide.iH;
        var w = currSlide.iW;
        var backupSrc = currSlide.content.data('video-backup-src');

        videoPlayer = _Rover2.default.video.player({
          container: slider.videoObj,
          width: '100%',
          aspectRatio: w + ':' + h,
          autoPlay: true
        });

        videoPlayer.load(videoSrc, backupSrc);
      });
    });

    slider.ev.on('rsOnDestroyVideoElement', function (e) {
      videoPlayer.remove();
    });
    slider.ev.on('rsAfterSlideChange', function (e) {
      _this.recordViewEvent();
    });
  },
  recordViewEvent: function recordViewEvent() {
    var eventName = this.options.recordedEvent;
    if (!eventName) {
      return;
    }
    var slide = this.options.slides[this.royalSlider.currSlideId];
    var opk = slide ? slide.opk : '';
    _dataLayer2.default.push({
      event: eventName,
      imageId: opk,
      providerId: _Rover2.default.context.providerId
    });
  },
  onModalShown: function onModalShown() {
    this.royalSlider.updateSliderSize();
    _rover_modal2.default.prototype.onModalShown.call(this);
    this.recordViewEvent();
  },
  openTo: function openTo(index) {
    this.royalSlider.goTo(index);
    this.open();
  },
  getSlideMarkup: function getSlideMarkup(slide) {
    return this.slideTemplates[slide.type].render(slide);
  },
  getGalleryMarkup: function getGalleryMarkup(slides) {
    var _this2 = this;

    var markup = '';

    _underscore2.default.each(slides, function (slide) {
      markup += _this2.getSlideMarkup(slide);
    });

    return markup;
  }
});

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _undefined = __webpack_require__(968)(); // Support ES3 engines

module.exports = function (val) {
 return (val !== _undefined) && (val !== null);
};


/***/ }),

/***/ 586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRouteURL", function() { return getRouteURL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__url__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cookie__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__injector__ = __webpack_require__(26);





var getRouteURL = function getRouteURL() {
  var deeplink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'rover://campaign/';

  var shouldIncludeMobileNativePushParam = Object(__WEBPACK_IMPORTED_MODULE_3__injector__["default"])('Rover.context.shouldIncludeMobileNativePushParam', false);

  if (__WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].deeplink) {
    deeplink = __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].deeplink;
  }

  // append Mobile Native Push UTM Params
  if (shouldIncludeMobileNativePushParam) {
    __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].UTMParameters = {
      utm_source: 'app_install_banner',
      utm_medium: 'web',
      utm_campaign: 'quick_match_landing_20180102'
    };
  }

  // append utm parameters if they exist
  if (__WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].UTMParameters) {
    deeplink = Object(__WEBPACK_IMPORTED_MODULE_1__url__["appendUrlParams"])(deeplink, __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].UTMParameters);
  }

  if (__WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].firstHttpReferrer) {
    deeplink = Object(__WEBPACK_IMPORTED_MODULE_1__url__["appendUrlParams"])(deeplink, {
      http_referrer: encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].firstHttpReferrer)
    });
  }

  // append Ambassador params if they exist
  var ambassadorMbsyCode = Object(__WEBPACK_IMPORTED_MODULE_1__url__["getUrlParameter"])('mbsy');
  if (ambassadorMbsyCode) {
    var campaignId = Object(__WEBPACK_IMPORTED_MODULE_1__url__["getUrlParameter"])('campaignid');
    deeplink = Object(__WEBPACK_IMPORTED_MODULE_1__url__["appendUrlParams"])(deeplink, {
      mbsy: ambassadorMbsyCode,
      campaignid: campaignId
    });
  }

  // append rover_cid
  var roverCid = Object(__WEBPACK_IMPORTED_MODULE_2__cookie__["getCookie"])('rover_cid');
  if (roverCid) {
    deeplink = Object(__WEBPACK_IMPORTED_MODULE_1__url__["appendUrlParams"])(deeplink, { rover_cid: roverCid });
  }

  // Deeplink needs the protocol removed
  var afterClickUrl = encodeURIComponent(window.location.href);
  var deeplinkPath = encodeURIComponent(deeplink.split('rover://')[1]);
  var routeURL = Object(__WEBPACK_IMPORTED_MODULE_1__url__["appendUrlParams"])('https://r.rover.com/a/' + __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].context.branchKey, { $deeplink_path: deeplinkPath, $after_click_url: afterClickUrl });

  return routeURL;
};

/***/ }),

/***/ 790:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ajax = __webpack_require__(935);

var _ajax2 = _interopRequireDefault(_ajax);

var _auth = __webpack_require__(786);

var _auth2 = _interopRequireDefault(_auth);

var _carousels = __webpack_require__(953);

var _carousels2 = _interopRequireDefault(_carousels);

var _events = __webpack_require__(582);

var _events2 = _interopRequireDefault(_events);

var _fancybox = __webpack_require__(954);

var _fancybox2 = _interopRequireDefault(_fancybox);

var _flagListing = __webpack_require__(955);

var _flagListing2 = _interopRequireDefault(_flagListing);

var _gusTips = __webpack_require__(796);

var _gusTips2 = _interopRequireDefault(_gusTips);

var _textUtilities = __webpack_require__(956);

var _textUtilities2 = _interopRequireDefault(_textUtilities);

var _validation = __webpack_require__(797);

var _validation2 = _interopRequireDefault(_validation);

var _console = __webpack_require__(957);

var _console2 = _interopRequireDefault(_console);

var _jqueryFixes = __webpack_require__(958);

var _jqueryFixes2 = _interopRequireDefault(_jqueryFixes);

var _AloomaInitializer = __webpack_require__(959);

var _AloomaInitializer2 = _interopRequireDefault(_AloomaInitializer);

var _buttons = __webpack_require__(976);

var _buttons2 = _interopRequireDefault(_buttons);

var _fastclick = __webpack_require__(978);

var _fastclick2 = _interopRequireDefault(_fastclick);

var _galleries = __webpack_require__(980);

var _galleries2 = _interopRequireDefault(_galleries);

var _modals = __webpack_require__(798);

var _modals2 = _interopRequireDefault(_modals);

var _Authenticated = __webpack_require__(784);

var _Authenticated2 = _interopRequireDefault(_Authenticated);

var _email_capture_footer_form = __webpack_require__(981);

var _email_capture_footer_form2 = _interopRequireDefault(_email_capture_footer_form);

var _InternalReferrer = __webpack_require__(799);

var _InternalReferrer2 = _interopRequireDefault(_InternalReferrer);

var _AppInstallBanner = __webpack_require__(982);

var _AppInstallBanner2 = _interopRequireDefault(_AppInstallBanner);

var _ZendeskHelp = __webpack_require__(983);

var _ZendeskHelp2 = _interopRequireDefault(_ZendeskHelp);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This stays outside the IIFE since it needs to
// fire events before Vue components are loaded

(0, _jquery2.default)(function () {
  _InternalReferrer2.default.init();
  _ajax2.default.init();
  _email_capture_footer_form2.default.init();
  _AppInstallBanner2.default.init();
  _ZendeskHelp2.default.init();

  _auth2.default.init();
  _buttons2.default.init();
  _carousels2.default.init();
  _events2.default.init();
  _fancybox2.default.init();
  _fastclick2.default.init();
  _flagListing2.default.init();
  _gusTips2.default.init();
  _modals2.default.init();
  _textUtilities2.default.init();
  _validation2.default.init();
  _console2.default.init();
  _galleries2.default.init();
  _jqueryFixes2.default.init();
  _Authenticated2.default.init();
  _AloomaInitializer2.default.init();
});

/***/ }),

/***/ 796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(2);


function init() {
  var $gusTips = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-gus-tip');
  $gusTips.each(function () {
    var $this = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(this);
    var shouldShow = __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].cookie($this.data('gus-tip-cookie')) !== 'dismissed';
    if (shouldShow) {
      $this.show();
    }
  });
}

function handleGusTipDismiss() {
  var $gusTip = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(this).closest('.js-gus-tip');
  __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].cookie($gusTip.data('gus-tip-cookie'), 'dismissed', { expires: 180 });
  $gusTip.hide();
}

/* harmony default export */ __webpack_exports__["default"] = ({
  init: init,
  handleGusTipDismiss: handleGusTipDismiss
});

/***/ }),

/***/ 798:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Rover = __webpack_require__(3);

var _Rover2 = _interopRequireDefault(_Rover);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _rover_modal = __webpack_require__(90);

var _rover_modal2 = _interopRequireDefault(_rover_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function showModal() {
  var options = {
    content: (0, _jquery2.default)((0, _jquery2.default)(this).attr('data-target')).html(),
    title: (0, _jquery2.default)(this).attr('data-title'),
    disableCancel: (0, _jquery2.default)(this).attr('data-modal-blocking'),
    padding: !((0, _jquery2.default)(this).attr('data-modal-padding') === 'false')
  };

  var modal = new _rover_modal2.default(options);

  modal.open();
}

function initializeBlockingModal() {
  if (_Rover2.default.disable_blocking_modal) return;
  if ((0, _jquery2.default)(document.body).hasClass('js-disable-blocking-modal')) return;

  _Rover2.default.blocking_modals.handleBlockingModal();
}

function init() {
  initializeBlockingModal();
}

exports.default = {
  init: init,
  showModal: showModal,
  initializeBlockingModal: initializeBlockingModal
};

/***/ }),

/***/ 799:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookie = __webpack_require__(367);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  _createClass(_class, null, [{
    key: 'init',
    value: function init() {
      this.setEntryPageCookie();
      this.setUtmCookies();
    }
  }, {
    key: 'getUrlParam',
    value: function getUrlParam(name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
    }
  }, {
    key: 'getUrlLocation',
    value: function getUrlLocation() {
      return escape(window.location.pathname);
    }
  }, {
    key: 'setEntryPageCookie',
    value: function setEntryPageCookie() {
      if (!(0, _cookie.hasCookie)('entry_page')) {
        (0, _cookie.createCookie)('entry_page', this.getUrlLocation(), 999999);
      }
    }
  }, {
    key: 'setUtmCookies',
    value: function setUtmCookies() {
      var _this = this;

      var utmParams = ['campaign', 'source', 'medium', 'content', 'term'];
      var override = this.getUrlParam('utm_nooverride') !== '1';
      var hasFirstTimestamp = (0, _cookie.hasCookie)('f_iso');
      var timestamp = new Date().toISOString();

      utmParams.forEach(function (param) {
        var utmParam = 'utm_' + param;
        var utmValue = _this.getUrlParam(utmParam);
        if (!utmValue) return;

        if (!hasFirstTimestamp) {
          (0, _cookie.createCookie)('f_' + utmParam, utmValue, 365);
          (0, _cookie.createCookie)('f_iso', timestamp, 365);
        }

        if (!hasFirstTimestamp || override) {
          (0, _cookie.createCookie)('l_' + utmParam, utmValue, 365);
          (0, _cookie.createCookie)('l_iso', timestamp, 365);
        }
      });
    }
  }, {
    key: 'getCookie',
    value: function getCookie(name) {
      return (0, _cookie.getCookie)(name);
    }
  }, {
    key: 'createCookie',
    value: function createCookie(name, value, days) {
      (0, _cookie.createCookie)(name, value, days);
    }
  }, {
    key: 'hasCookie',
    value: function hasCookie(name) {
      return (0, _cookie.hasCookie)(name);
    }
  }]);

  return _class;
}();

exports.default = _class;

/***/ }),

/***/ 934:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(790);


/***/ }),

/***/ 935:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var initJQueryHeaders = function initJQueryHeaders() {
  __WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"].ajaxSetup({ headers: __WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].api.getSourceHeader() });

  Object(__WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"])(document).ajaxSend(function (e, jqxhr, settings) {
    var token = __WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].utils.getCsrfToken();

    if (!token) return;

    if (window.isRoverURL(settings.url)) {
      jqxhr.setRequestHeader('X-CSRFToken', token);
    }
  });
};

var initAxiosHeaders = function initAxiosHeaders() {
  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.request.use(function (config) {
    // if we're requesting a rover url
    if (config.url.includes(window.location.host) || config.url.startsWith('/') || config.url.startsWith('./') || config.url.startsWith('../')) {
      var clone = _extends({}, config);
      // clone the config and add our custom headers
      clone.headers.common = _extends({}, config.headers.common, __WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].api.getSourceHeader());
      var token = __WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].utils.getCsrfToken();
      if (token) {
        clone.headers.common['X-CSRFToken'] = token;
      }
      return clone;
    }
    // non-rover urls get NOTHING. so as to avoid CORS issues
    return config;
  }, function (error) {
    return Promise.reject(error);
  });
};

function init() {
  initJQueryHeaders();
  initAxiosHeaders();
}

/* harmony default export */ __webpack_exports__["default"] = ({
  init: init
});

/***/ }),

/***/ 953:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(2);


function init() {
  /**
   * Ajax support for carousel images.
   * Whenever a carousel slides, look for images in the
   * next slide that need to be loaded asynchronously.
   */
  Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(document).on('slide.bs.carousel', '[data-ride="carousel"]', function (e) {
    // Find the images in the the new slide that need loading
    var srcAttrName = 'data-src',
        loadingClass = 'rover-loading',
        $newSlide = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(e.relatedTarget),
        $imagesToProcess = $newSlide.find('img[' + srcAttrName + ']');

    $imagesToProcess.each(function () {
      // Find the image source that needs to be loaded
      var $img = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(this),
          newSrc = $img.attr(srcAttrName),
          $tmpImg = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('<img>');

      // Define behavior for when the image is finished loading
      $tmpImg.load(function () {
        $img.removeAttr(srcAttrName);
        $img.attr('src', newSrc);
        $img.unwrap();
        $newSlide.trigger('loaded');
      });

      // Update UI to reflect loading and start loading image
      $img.wrap('<div class="img-responsive ' + loadingClass + '"></div>');
      $tmpImg.attr('src', newSrc);
    });
  });
}

/* harmony default export */ __webpack_exports__["default"] = ({
  init: init
});

/***/ }),

/***/ 954:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(2);


function init() {
  if (__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].isFunction(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].fancybox)) {
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(document).on('click', '.fancybox-close', __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].fancybox.close);
  }
}

/* harmony default export */ __webpack_exports__["default"] = ({
  init: init
});

/***/ }),

/***/ 955:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Alerts__ = __webpack_require__(24);




var flagFormSubmitSuccess = function flagFormSubmitSuccess(response, status, xhr, $form) {
  $form.closest('.js-feedback-modal').modal('hide');
  __WEBPACK_IMPORTED_MODULE_1__Alerts__["default"].showToast({
    severity: 'success',
    message: "Thank you for flagging this. We'll look at it as soon as possible"
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(window).scrollTop(0);
};

function init() {
  this.$flagForm = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-flag-form');
  this.$flagForm.validate({
    rules: {
      comment: {
        required: true,
        minWords: 4
      }
    }
  });
  this.$flagForm.autoDisableAndValidateAjaxForm({
    success: flagFormSubmitSuccess,
    resetForm: true
  });

  if (window.location.hash === '#flag_dialog') {
    Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-flag-button').trigger('click');
  }
}

/* harmony default export */ __webpack_exports__["default"] = ({
  init: init
});

/***/ }),

/***/ 956:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(2);


function getWords(s) {
  var trimmedString = s.replace(/(^\s*)|(\s*$)/gi, '');
  if (trimmedString === '') return [];
  return trimmedString.split(/\s+/);
}

function getWordCount(s) {
  return getWords(s).length;
}

__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].fn.wordCount = function wordCount() {
  return getWordCount(Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(this).val());
};

function updateWordCount(e) {
  var $el = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(e.currentTarget);
  var wordCount = getWordCount($el.val());
  var minWords = $el.attr('data-min-words');
  if (minWords) wordCount = minWords - wordCount;
  $el.siblings().find('.js-word-count-input-counter').html(Math.max(0, wordCount));
}

function updateCharCount(evt) {
  var $target = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(evt.target);
  $target.siblings().find('.js-char-count-input-counter').html($target.val().length);
}

function initWordCount() {
  Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-word-count-input').trigger('input');
}

function initCharCount() {
  Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-char-count-input').trigger('input');
}

function init() {
  Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-word-count-input').on('input', updateWordCount);
  Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('.js-char-count-input').on('input', updateCharCount);

  initWordCount();
  initCharCount();
}

/* harmony default export */ __webpack_exports__["default"] = ({
  init: init,
  getWords: getWords,
  getWordCount: getWordCount,
  updateWordCount: updateWordCount,
  updateCharCount: updateCharCount,
  initWordCount: initWordCount,
  initCharCount: initCharCount
});

/***/ }),

/***/ 957:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function init() {
  /**
   * Ensure that window always has the hasOwnProperty method on it, as
   * older versions of IE do not have this, and we are testing for jQuery presence
   * using it.
   */
  window.hasOwnProperty = function (obj) {
    return !!this[obj];
  };

  /**
   * Prevent errors from calls to console.* from browsers that don't support it.
   */
  if (!window.hasOwnProperty('console')) {
    window.console = {
      assert: function assert() {},
      clear: function clear() {},
      count: function count() {},
      debug: function debug() {},
      dir: function dir() {},
      dirxml: function dirxml() {},
      error: function error() {},
      exception: function exception() {},
      group: function group() {},
      groupCollapsed: function groupCollapsed() {},
      groupEnd: function groupEnd() {},
      info: function info() {},
      log: function log() {},
      profile: function profile() {},
      profileEnd: function profileEnd() {},
      table: function table() {},
      time: function time() {},
      timeEnd: function timeEnd() {},
      timeStamp: function timeStamp() {},
      trace: function trace() {},
      warn: function warn() {}
    };
  }
}

/* harmony default export */ __webpack_exports__["default"] = ({
  init: init
});

/***/ }),

/***/ 958:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(2);


function init() {
    /**
     * Fix jQuery show to work better with Bootstrap hidden/hide classes
     * https://github.com/twbs/bootstrap/issues/9237
     */
    var show = __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].fn.show;
    __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].fn.show = function () {
        this.removeClass('hidden hide');
        return show.call(this);
    };

    /**
     * Recursively strip whitespace between child elements.
     */
    __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].fn.removeWhitespace = function () {
        this.contents().filter(function () {
            if (this.nodeType == 3) {
                return !/\S/.test(this.nodeValue);
            } else {
                Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(this).removeWhitespace();
                return false;
            }
        }).remove();
        return this;
    };
}

/* harmony default export */ __webpack_exports__["default"] = ({
    init: init
});

/***/ }),

/***/ 959:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../globals/Rover.js
var Rover = __webpack_require__(3);

// CONCATENATED MODULE: ../globals/alooma.js
window.alooma = window.alooma || {};
/* harmony default export */ var alooma = (window.alooma);
// EXTERNAL MODULE: ../node_modules/event-emitter/index.js
var event_emitter = __webpack_require__(960);
var event_emitter_default = /*#__PURE__*/__webpack_require__.n(event_emitter);

// CONCATENATED MODULE: ../utilities/aloomaWrapper.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// window.alooma is used by external applications (GTM), so don't remove
window.alooma = window.alooma || {};

var aloomaWrapper_AloomaWrapper = function () {
  function AloomaWrapper() {
    _classCallCheck(this, AloomaWrapper);

    this.ALOOMA_LOADED = 'alooma:loaded';
    this.isAloomaLoaded = false;
    this.registry = {};
    this.sequence = 0;
    this.emitter = event_emitter_default()();
    this.alooma = window.alooma;
  }

  _createClass(AloomaWrapper, [{
    key: 'track',
    value: function track(eventName, props, cb) {
      var _this = this;

      return this.waitForAloomaLoaded().then(function () {
        var clone = _extends({}, _this.registry, props, { sequence: _this.sequence });
        _this.sequence += 1;
        _this.alooma.track(eventName, clone, cb);
      });
    }
  }, {
    key: 'register',
    value: function register(dataObj) {
      this.registry = _extends({}, this.registry, dataObj);
    }
  }, {
    key: 'save',
    value: function save(dataObj) {
      var _this2 = this;

      return this.waitForAloomaLoaded().then(function () {
        return _this2.alooma.register(dataObj);
      });
    }
  }, {
    key: 'waitForAloomaLoaded',
    value: function waitForAloomaLoaded() {
      var _this3 = this;

      return new Promise(function (resolve) {
        if (_this3.isAloomaLoaded) return resolve();
        return _this3.emitter.on(_this3.ALOOMA_LOADED, resolve);
      });
    }
  }, {
    key: 'aloomaLoaded',
    value: function aloomaLoaded() {
      if (!this.isAloomaLoaded) {
        this.alooma.track_pageview();
      }

      this.isAloomaLoaded = true;
      this.emitter.emit(this.ALOOMA_LOADED);
    }
  }]);

  return AloomaWrapper;
}();

// window.aloomaWrapper is used by external applications (GTM), so don't remove


window.aloomaWrapper = new aloomaWrapper_AloomaWrapper();

/* harmony default export */ var aloomaWrapper = (window.aloomaWrapper);
// CONCATENATED MODULE: ../utilities/AloomaInitializer.js
var AloomaInitializer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function AloomaInitializer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var AloomaInitializer_Alooma = function () {
  function Alooma() {
    AloomaInitializer__classCallCheck(this, Alooma);
  }

  AloomaInitializer__createClass(Alooma, null, [{
    key: 'init',
    value: function init() {
      if (alooma.set_config) {
        alooma.set_config({ track_pageview: false });
      }

      var d = new Date();
      aloomaWrapper.register({ timezone_offset: d.getTimezoneOffset() });

      if (Rover["default"].alooma && Rover["default"].alooma.json) {
        aloomaWrapper.register(Rover["default"].alooma.json);
      }

      if (Rover["default"].gtm && Rover["default"].gtm.pageCategory) {
        aloomaWrapper.register({ pageCategory: Rover["default"].gtm.pageCategory });
      } else {
        aloomaWrapper.register({ pageCategory: 'uncategorized' });
      }

      if (Object.keys(alooma).length) {
        aloomaWrapper.aloomaLoaded();
      }
    }
  }]);

  return Alooma;
}();

/* harmony default export */ var AloomaInitializer = __webpack_exports__["default"] = (AloomaInitializer_Alooma);


AloomaInitializer_Alooma.init();

/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var d        = __webpack_require__(961)
  , callable = __webpack_require__(975)

  , apply = Function.prototype.apply, call = Function.prototype.call
  , create = Object.create, defineProperty = Object.defineProperty
  , defineProperties = Object.defineProperties
  , hasOwnProperty = Object.prototype.hasOwnProperty
  , descriptor = { configurable: true, enumerable: false, writable: true }

  , on, once, off, emit, methods, descriptors, base;

on = function (type, listener) {
	var data;

	callable(listener);

	if (!hasOwnProperty.call(this, '__ee__')) {
		data = descriptor.value = create(null);
		defineProperty(this, '__ee__', descriptor);
		descriptor.value = null;
	} else {
		data = this.__ee__;
	}
	if (!data[type]) data[type] = listener;
	else if (typeof data[type] === 'object') data[type].push(listener);
	else data[type] = [data[type], listener];

	return this;
};

once = function (type, listener) {
	var once, self;

	callable(listener);
	self = this;
	on.call(this, type, once = function () {
		off.call(self, type, once);
		apply.call(listener, this, arguments);
	});

	once.__eeOnceListener__ = listener;
	return this;
};

off = function (type, listener) {
	var data, listeners, candidate, i;

	callable(listener);

	if (!hasOwnProperty.call(this, '__ee__')) return this;
	data = this.__ee__;
	if (!data[type]) return this;
	listeners = data[type];

	if (typeof listeners === 'object') {
		for (i = 0; (candidate = listeners[i]); ++i) {
			if ((candidate === listener) ||
					(candidate.__eeOnceListener__ === listener)) {
				if (listeners.length === 2) data[type] = listeners[i ? 0 : 1];
				else listeners.splice(i, 1);
			}
		}
	} else {
		if ((listeners === listener) ||
				(listeners.__eeOnceListener__ === listener)) {
			delete data[type];
		}
	}

	return this;
};

emit = function (type) {
	var i, l, listener, listeners, args;

	if (!hasOwnProperty.call(this, '__ee__')) return;
	listeners = this.__ee__[type];
	if (!listeners) return;

	if (typeof listeners === 'object') {
		l = arguments.length;
		args = new Array(l - 1);
		for (i = 1; i < l; ++i) args[i - 1] = arguments[i];

		listeners = listeners.slice();
		for (i = 0; (listener = listeners[i]); ++i) {
			apply.call(listener, this, args);
		}
	} else {
		switch (arguments.length) {
		case 1:
			call.call(listeners, this);
			break;
		case 2:
			call.call(listeners, this, arguments[1]);
			break;
		case 3:
			call.call(listeners, this, arguments[1], arguments[2]);
			break;
		default:
			l = arguments.length;
			args = new Array(l - 1);
			for (i = 1; i < l; ++i) {
				args[i - 1] = arguments[i];
			}
			apply.call(listeners, this, args);
		}
	}
};

methods = {
	on: on,
	once: once,
	off: off,
	emit: emit
};

descriptors = {
	on: d(on),
	once: d(once),
	off: d(off),
	emit: d(emit)
};

base = defineProperties({}, descriptors);

module.exports = exports = function (o) {
	return (o == null) ? create(base) : defineProperties(Object(o), descriptors);
};
exports.methods = methods;


/***/ }),

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign        = __webpack_require__(962)
  , normalizeOpts = __webpack_require__(970)
  , isCallable    = __webpack_require__(971)
  , contains      = __webpack_require__(972)

  , d;

d = module.exports = function (dscr, value/*, options*/) {
	var c, e, w, options, desc;
	if ((arguments.length < 2) || (typeof dscr !== 'string')) {
		options = value;
		value = dscr;
		dscr = null;
	} else {
		options = arguments[2];
	}
	if (dscr == null) {
		c = w = true;
		e = false;
	} else {
		c = contains.call(dscr, 'c');
		e = contains.call(dscr, 'e');
		w = contains.call(dscr, 'w');
	}

	desc = { value: value, configurable: c, enumerable: e, writable: w };
	return !options ? desc : assign(normalizeOpts(options), desc);
};

d.gs = function (dscr, get, set/*, options*/) {
	var c, e, options, desc;
	if (typeof dscr !== 'string') {
		options = set;
		set = get;
		get = dscr;
		dscr = null;
	} else {
		options = arguments[3];
	}
	if (get == null) {
		get = undefined;
	} else if (!isCallable(get)) {
		options = get;
		get = set = undefined;
	} else if (set == null) {
		set = undefined;
	} else if (!isCallable(set)) {
		options = set;
		set = undefined;
	}
	if (dscr == null) {
		c = true;
		e = false;
	} else {
		c = contains.call(dscr, 'c');
		e = contains.call(dscr, 'e');
	}

	desc = { get: get, set: set, configurable: c, enumerable: e };
	return !options ? desc : assign(normalizeOpts(options), desc);
};


/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(963)()
	? Object.assign
	: __webpack_require__(964);


/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	var assign = Object.assign, obj;
	if (typeof assign !== "function") return false;
	obj = { foo: "raz" };
	assign(obj, { bar: "dwa" }, { trzy: "trzy" });
	return (obj.foo + obj.bar + obj.trzy) === "razdwatrzy";
};


/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys  = __webpack_require__(965)
  , value = __webpack_require__(969)
  , max   = Math.max;

module.exports = function (dest, src /*, …srcn*/) {
	var error, i, length = max(arguments.length, 2), assign;
	dest = Object(value(dest));
	assign = function (key) {
		try {
			dest[key] = src[key];
		} catch (e) {
			if (!error) error = e;
		}
	};
	for (i = 1; i < length; ++i) {
		src = arguments[i];
		keys(src).forEach(assign);
	}
	if (error !== undefined) throw error;
	return dest;
};


/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(966)()
	? Object.keys
	: __webpack_require__(967);


/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	try {
		Object.keys("primitive");
		return true;
	} catch (e) {
 return false;
}
};


/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(585);

var keys = Object.keys;

module.exports = function (object) {
	return keys(isValue(object) ? Object(object) : object);
};


/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// eslint-disable-next-line no-empty-function
module.exports = function () {};


/***/ }),

/***/ 969:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(585);

module.exports = function (value) {
	if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
	return value;
};


/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(585);

var forEach = Array.prototype.forEach, create = Object.create;

var process = function (src, obj) {
	var key;
	for (key in src) obj[key] = src[key];
};

// eslint-disable-next-line no-unused-vars
module.exports = function (opts1 /*, …options*/) {
	var result = create(null);
	forEach.call(arguments, function (options) {
		if (!isValue(options)) return;
		process(Object(options), result);
	});
	return result;
};


/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Deprecated



module.exports = function (obj) {
 return typeof obj === "function";
};


/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(973)()
	? String.prototype.contains
	: __webpack_require__(974);


/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var str = "razdwatrzy";

module.exports = function () {
	if (typeof str.contains !== "function") return false;
	return (str.contains("dwa") === true) && (str.contains("foo") === false);
};


/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var indexOf = String.prototype.indexOf;

module.exports = function (searchString/*, position*/) {
	return indexOf.call(this, searchString, arguments[1]) > -1;
};


/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fn) {
	if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
	return fn;
};


/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _events = __webpack_require__(582);

var _events2 = _interopRequireDefault(_events);

var _gusTips = __webpack_require__(796);

var _gusTips2 = _interopRequireDefault(_gusTips);

var _howItWorks = __webpack_require__(977);

var _howItWorks2 = _interopRequireDefault(_howItWorks);

var _modals = __webpack_require__(798);

var _modals2 = _interopRequireDefault(_modals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init() {
  var btn = _jquery2.default.fn.button.noConflict(); // reverts $.fn.button to jqueryui btn
  _jquery2.default.fn.btn = btn; // assigns bootstrap button functionality to $.fn.btn
  (0, _jquery2.default)('.rover-btn').btn();

  // Enable button toggling functionality for rover buttons. Bootstrap hardcodes
  // their listener on .btn, so we have to do the same for .rover-btn
  (0, _jquery2.default)(document).on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
    var $roverBtn = (0, _jquery2.default)(e.target);

    // Account for the case when the click event occurred on something
    // inside the rover button
    if (!$roverBtn.hasClass('rover-btn')) {
      $roverBtn = $roverBtn.closest('.rover-btn');
    }

    $roverBtn.btn('toggle');
    e.preventDefault();
  });

  (0, _jquery2.default)('.js-gus-tip-dismiss').on('click', _gusTips2.default.handleGusTipDismiss);
  (0, _jquery2.default)('.js-show-modal').on('click', _modals2.default.showModal);
  (0, _jquery2.default)('.js-disable-click').on('click', disableClick);

  (0, _jquery2.default)(document).on('click', '.js-datepicker-calendar-trigger', handleCalendarButtonClick);
  (0, _jquery2.default)(document).on('click', '.js-timepicker-clock-trigger', handleClockButtonClick);
  (0, _jquery2.default)(document).on('click', '.js-clickable-for-radio', selectRadio);
  (0, _jquery2.default)(document).on('click', '.js-how-it-works .close, .js-how-it-works-trigger', _howItWorks2.default.toggle);
  (0, _jquery2.default)(document).on('click', '[data-record-click-event]', _events2.default.recordClickEventHandler);
}

function disableClick() {
  return false;
}

function selectRadio() {
  (0, _jquery2.default)(this).find('input[type="radio"]:not(:disabled)').prop('checked', true);
}

function handleClockButtonClick(e) {
  e.preventDefault();
  var $this = (0, _jquery2.default)(this);
  var $trigger_target = (0, _jquery2.default)($this.attr('data-trigger-target'));
  if (!$trigger_target.length) {
    $trigger_target = $this.find('.js-timepicker');
  }
  $trigger_target.focus();
  $trigger_target.timepicker('show');
}

function handleCalendarButtonClick(e) {
  e.preventDefault();
  var $this = (0, _jquery2.default)(this);
  var $trigger_target = (0, _jquery2.default)($this.attr('data-trigger-target'));
  if (!$trigger_target.length) {
    $trigger_target = $this.find('.js-date-picker');
  }
  $trigger_target.datepicker('show');
}

exports.default = {
  init: init,
  disableClick: disableClick,
  handleClockButtonClick: handleClockButtonClick,
  handleCalendarButtonClick: handleCalendarButtonClick
};

/***/ }),

/***/ 977:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__ = __webpack_require__(3);


function toggle() {
  __WEBPACK_IMPORTED_MODULE_0__rover_globals_Rover__["default"].views.HeaderNavBarView.hideAllServices();

  if ($('.js-how-it-works').hasClass('in')) {
    $('.js-how-it-works').removeClass('in');
  } else {
    $('.js-how-it-works').addClass('in');
    $('html, body').animate({
      scrollTop: 0
    }, 400);
  }
}

/* harmony default export */ __webpack_exports__["default"] = ({
  toggle: toggle
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fastclick = __webpack_require__(979);

var _fastclick2 = _interopRequireDefault(_fastclick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init() {
  _fastclick2.default.attach(document.body);
}

exports.default = {
  init: init
};

/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
 *
 * @version 1.0.1
 * @codingstandard ftlabs-jsv2
 * @copyright The Financial Times Limited [All Rights Reserved]
 * @license MIT License (see LICENSE.txt)
 */

/*jslint browser:true, node:true*/
/*global define, Event, Node*/


/**
 * Instantiate fast-clicking listeners on the specificed layer.
 *
 * @constructor
 * @param {Element} layer The layer to listen on
 * @param {Object} options The options to override the defaults
 */
function FastClick(layer, options) {
	'use strict';
	var oldOnClick;

	options = options || {};

	/**
	 * Whether a click is currently being tracked.
	 *
	 * @type boolean
	 */
	this.trackingClick = false;


	/**
	 * Timestamp for when click tracking started.
	 *
	 * @type number
	 */
	this.trackingClickStart = 0;


	/**
	 * The element being tracked for a click.
	 *
	 * @type EventTarget
	 */
	this.targetElement = null;


	/**
	 * X-coordinate of touch start event.
	 *
	 * @type number
	 */
	this.touchStartX = 0;


	/**
	 * Y-coordinate of touch start event.
	 *
	 * @type number
	 */
	this.touchStartY = 0;


	/**
	 * ID of the last touch, retrieved from Touch.identifier.
	 *
	 * @type number
	 */
	this.lastTouchIdentifier = 0;


	/**
	 * Touchmove boundary, beyond which a click will be cancelled.
	 *
	 * @type number
	 */
	this.touchBoundary = options.touchBoundary || 10;


	/**
	 * The FastClick layer.
	 *
	 * @type Element
	 */
	this.layer = layer;

	/**
	 * The minimum time between tap(touchstart and touchend) events
	 *
	 * @type number
	 */
	this.tapDelay = options.tapDelay || 200;

	if (FastClick.notNeeded(layer)) {
		return;
	}

	// Some old versions of Android don't have Function.prototype.bind
	function bind(method, context) {
		return function() { return method.apply(context, arguments); };
	}


	var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
	var context = this;
	for (var i = 0, l = methods.length; i < l; i++) {
		context[methods[i]] = bind(context[methods[i]], context);
	}

	// Set up event handlers as required
	if (deviceIsAndroid) {
		layer.addEventListener('mouseover', this.onMouse, true);
		layer.addEventListener('mousedown', this.onMouse, true);
		layer.addEventListener('mouseup', this.onMouse, true);
	}

	layer.addEventListener('click', this.onClick, true);
	layer.addEventListener('touchstart', this.onTouchStart, false);
	layer.addEventListener('touchmove', this.onTouchMove, false);
	layer.addEventListener('touchend', this.onTouchEnd, false);
	layer.addEventListener('touchcancel', this.onTouchCancel, false);

	// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
	// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
	// layer when they are cancelled.
	if (!Event.prototype.stopImmediatePropagation) {
		layer.removeEventListener = function(type, callback, capture) {
			var rmv = Node.prototype.removeEventListener;
			if (type === 'click') {
				rmv.call(layer, type, callback.hijacked || callback, capture);
			} else {
				rmv.call(layer, type, callback, capture);
			}
		};

		layer.addEventListener = function(type, callback, capture) {
			var adv = Node.prototype.addEventListener;
			if (type === 'click') {
				adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
					if (!event.propagationStopped) {
						callback(event);
					}
				}), capture);
			} else {
				adv.call(layer, type, callback, capture);
			}
		};
	}

	// If a handler is already declared in the element's onclick attribute, it will be fired before
	// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
	// adding it as listener.
	if (typeof layer.onclick === 'function') {

		// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
		// - the old one won't work if passed to addEventListener directly.
		oldOnClick = layer.onclick;
		layer.addEventListener('click', function(event) {
			oldOnClick(event);
		}, false);
		layer.onclick = null;
	}
}


/**
 * Android requires exceptions.
 *
 * @type boolean
 */
var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0;


/**
 * iOS requires exceptions.
 *
 * @type boolean
 */
var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent);


/**
 * iOS 4 requires an exception for select elements.
 *
 * @type boolean
 */
var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);


/**
 * iOS 6.0(+?) requires the target element to be manually derived
 *
 * @type boolean
 */
var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS ([6-9]|\d{2})_\d/).test(navigator.userAgent);


/**
 * Determine whether a given element requires a native click.
 *
 * @param {EventTarget|Element} target Target DOM element
 * @returns {boolean} Returns true if the element needs a native click
 */
FastClick.prototype.needsClick = function(target) {
	'use strict';
	switch (target.nodeName.toLowerCase()) {

	// Don't send a synthetic click to disabled inputs (issue #62)
	case 'button':
	case 'select':
	case 'textarea':
		if (target.disabled) {
			return true;
		}

		break;
	case 'input':

		// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
		if ((deviceIsIOS && target.type === 'file') || target.disabled) {
			return true;
		}

		break;
	case 'label':
	case 'video':
		return true;
	}

	return (/\bneedsclick\b/).test(target.className);
};


/**
 * Determine whether a given element requires a call to focus to simulate click into element.
 *
 * @param {EventTarget|Element} target Target DOM element
 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
 */
FastClick.prototype.needsFocus = function(target) {
	'use strict';
	switch (target.nodeName.toLowerCase()) {
	case 'textarea':
		return true;
	case 'select':
		return !deviceIsAndroid;
	case 'input':
		switch (target.type) {
		case 'button':
		case 'checkbox':
		case 'file':
		case 'image':
		case 'radio':
		case 'submit':
			return false;
		}

		// No point in attempting to focus disabled inputs
		return !target.disabled && !target.readOnly;
	default:
		return (/\bneedsfocus\b/).test(target.className);
	}
};


/**
 * Send a click event to the specified element.
 *
 * @param {EventTarget|Element} targetElement
 * @param {Event} event
 */
FastClick.prototype.sendClick = function(targetElement, event) {
	'use strict';
	var clickEvent, touch;

	// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
	if (document.activeElement && document.activeElement !== targetElement) {
		document.activeElement.blur();
	}

	touch = event.changedTouches[0];

	// Synthesise a click event, with an extra attribute so it can be tracked
	clickEvent = document.createEvent('MouseEvents');
	clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
	clickEvent.forwardedTouchEvent = true;
	targetElement.dispatchEvent(clickEvent);
};

FastClick.prototype.determineEventType = function(targetElement) {
	'use strict';

	//Issue #159: Android Chrome Select Box does not open with a synthetic click event
	if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
		return 'mousedown';
	}

	return 'click';
};


/**
 * @param {EventTarget|Element} targetElement
 */
FastClick.prototype.focus = function(targetElement) {
	'use strict';
	var length;

	// Issue #160: on iOS 7, some input elements (e.g. date datetime) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
	if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time') {
		length = targetElement.value.length;
		targetElement.setSelectionRange(length, length);
	} else {
		targetElement.focus();
	}
};


/**
 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
 *
 * @param {EventTarget|Element} targetElement
 */
FastClick.prototype.updateScrollParent = function(targetElement) {
	'use strict';
	var scrollParent, parentElement;

	scrollParent = targetElement.fastClickScrollParent;

	// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
	// target element was moved to another parent.
	if (!scrollParent || !scrollParent.contains(targetElement)) {
		parentElement = targetElement;
		do {
			if (parentElement.scrollHeight > parentElement.offsetHeight) {
				scrollParent = parentElement;
				targetElement.fastClickScrollParent = parentElement;
				break;
			}

			parentElement = parentElement.parentElement;
		} while (parentElement);
	}

	// Always update the scroll top tracker if possible.
	if (scrollParent) {
		scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
	}
};


/**
 * @param {EventTarget} targetElement
 * @returns {Element|EventTarget}
 */
FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {
	'use strict';

	// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
	if (eventTarget.nodeType === Node.TEXT_NODE) {
		return eventTarget.parentNode;
	}

	return eventTarget;
};


/**
 * On touch start, record the position and scroll offset.
 *
 * @param {Event} event
 * @returns {boolean}
 */
FastClick.prototype.onTouchStart = function(event) {
	'use strict';
	var targetElement, touch, selection;

	// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
	if (event.targetTouches.length > 1) {
		return true;
	}

	targetElement = this.getTargetElementFromEventTarget(event.target);
	touch = event.targetTouches[0];

	if (touch && deviceIsIOS) {

		// Only trusted events will deselect text on iOS (issue #49)
		selection = window.getSelection();
		if (selection.rangeCount && !selection.isCollapsed) {
			return true;
		}

		if (!deviceIsIOS4) {

			// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
			// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
			// with the same identifier as the touch event that previously triggered the click that triggered the alert.
			// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
			// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
			if (touch.identifier === this.lastTouchIdentifier) {
				event.preventDefault();
				return false;
			}

			this.lastTouchIdentifier = touch.identifier;

			// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
			// 1) the user does a fling scroll on the scrollable layer
			// 2) the user stops the fling scroll with another tap
			// then the event.target of the last 'touchend' event will be the element that was under the user's finger
			// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
			// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
			this.updateScrollParent(targetElement);
		}
	}

	this.trackingClick = true;
	this.trackingClickStart = event.timeStamp;
	this.targetElement = targetElement;

	this.touchStartX = touch.pageX;
	this.touchStartY = touch.pageY;

	// Prevent phantom clicks on fast double-tap (issue #36)
	if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
		event.preventDefault();
	}

	return true;
};


/**
 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
 *
 * @param {Event} event
 * @returns {boolean}
 */
FastClick.prototype.touchHasMoved = function(event) {
	'use strict';
	var touch = event.changedTouches[0], boundary = this.touchBoundary;

	if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
		return true;
	}

	return false;
};


/**
 * Update the last position.
 *
 * @param {Event} event
 * @returns {boolean}
 */
FastClick.prototype.onTouchMove = function(event) {
	'use strict';
	if (!this.trackingClick) {
		return true;
	}

	// If the touch has moved, cancel the click tracking
	if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
		this.trackingClick = false;
		this.targetElement = null;
	}

	return true;
};


/**
 * Attempt to find the labelled control for the given label element.
 *
 * @param {EventTarget|HTMLLabelElement} labelElement
 * @returns {Element|null}
 */
FastClick.prototype.findControl = function(labelElement) {
	'use strict';

	// Fast path for newer browsers supporting the HTML5 control attribute
	if (labelElement.control !== undefined) {
		return labelElement.control;
	}

	// All browsers under test that support touch events also support the HTML5 htmlFor attribute
	if (labelElement.htmlFor) {
		return document.getElementById(labelElement.htmlFor);
	}

	// If no for attribute exists, attempt to retrieve the first labellable descendant element
	// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
	return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
};


/**
 * On touch end, determine whether to send a click event at once.
 *
 * @param {Event} event
 * @returns {boolean}
 */
FastClick.prototype.onTouchEnd = function(event) {
	'use strict';
	var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;

	if (!this.trackingClick) {
		return true;
	}

	// Prevent phantom clicks on fast double-tap (issue #36)
	if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
		this.cancelNextClick = true;
		return true;
	}

	// Reset to prevent wrong click cancel on input (issue #156).
	this.cancelNextClick = false;

	this.lastClickTime = event.timeStamp;

	trackingClickStart = this.trackingClickStart;
	this.trackingClick = false;
	this.trackingClickStart = 0;

	// On some iOS devices, the targetElement supplied with the event is invalid if the layer
	// is performing a transition or scroll, and has to be re-detected manually. Note that
	// for this to function correctly, it must be called *after* the event target is checked!
	// See issue #57; also filed as rdar://13048589 .
	if (deviceIsIOSWithBadTarget) {
		touch = event.changedTouches[0];

		// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
		targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
		targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
	}

	targetTagName = targetElement.tagName.toLowerCase();
	if (targetTagName === 'label') {
		forElement = this.findControl(targetElement);
		if (forElement) {
			this.focus(targetElement);
			if (deviceIsAndroid) {
				return false;
			}

			targetElement = forElement;
		}
	} else if (this.needsFocus(targetElement)) {

		// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
		// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
		if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
			this.targetElement = null;
			return false;
		}

		this.focus(targetElement);
		this.sendClick(targetElement, event);

		// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
		// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
		if (!deviceIsIOS || targetTagName !== 'select') {
			this.targetElement = null;
			event.preventDefault();
		}

		return false;
	}

	if (deviceIsIOS && !deviceIsIOS4) {

		// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
		// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
		scrollParent = targetElement.fastClickScrollParent;
		if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
			return true;
		}
	}

	// Prevent the actual click from going though - unless the target node is marked as requiring
	// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
	if (!this.needsClick(targetElement)) {
		event.preventDefault();
		this.sendClick(targetElement, event);
	}

	return false;
};


/**
 * On touch cancel, stop tracking the click.
 *
 * @returns {void}
 */
FastClick.prototype.onTouchCancel = function() {
	'use strict';
	this.trackingClick = false;
	this.targetElement = null;
};


/**
 * Determine mouse events which should be permitted.
 *
 * @param {Event} event
 * @returns {boolean}
 */
FastClick.prototype.onMouse = function(event) {
	'use strict';

	// If a target element was never set (because a touch event was never fired) allow the event
	if (!this.targetElement) {
		return true;
	}

	if (event.forwardedTouchEvent) {
		return true;
	}

	// Programmatically generated events targeting a specific element should be permitted
	if (!event.cancelable) {
		return true;
	}

	// Derive and check the target element to see whether the mouse event needs to be permitted;
	// unless explicitly enabled, prevent non-touch click events from triggering actions,
	// to prevent ghost/doubleclicks.
	if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

		// Prevent any user-added listeners declared on FastClick element from being fired.
		if (event.stopImmediatePropagation) {
			event.stopImmediatePropagation();
		} else {

			// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
			event.propagationStopped = true;
		}

		// Cancel the event
		event.stopPropagation();
		event.preventDefault();

		return false;
	}

	// If the mouse event is permitted, return true for the action to go through.
	return true;
};


/**
 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
 * an actual click which should be permitted.
 *
 * @param {Event} event
 * @returns {boolean}
 */
FastClick.prototype.onClick = function(event) {
	'use strict';
	var permitted;

	// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
	if (this.trackingClick) {
		this.targetElement = null;
		this.trackingClick = false;
		return true;
	}

	// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
	if (event.target.type === 'submit' && event.detail === 0) {
		return true;
	}

	permitted = this.onMouse(event);

	// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
	if (!permitted) {
		this.targetElement = null;
	}

	// If clicks are permitted, return true for the action to go through.
	return permitted;
};


/**
 * Remove all FastClick's event listeners.
 *
 * @returns {void}
 */
FastClick.prototype.destroy = function() {
	'use strict';
	var layer = this.layer;

	if (deviceIsAndroid) {
		layer.removeEventListener('mouseover', this.onMouse, true);
		layer.removeEventListener('mousedown', this.onMouse, true);
		layer.removeEventListener('mouseup', this.onMouse, true);
	}

	layer.removeEventListener('click', this.onClick, true);
	layer.removeEventListener('touchstart', this.onTouchStart, false);
	layer.removeEventListener('touchmove', this.onTouchMove, false);
	layer.removeEventListener('touchend', this.onTouchEnd, false);
	layer.removeEventListener('touchcancel', this.onTouchCancel, false);
};


/**
 * Check whether FastClick is needed.
 *
 * @param {Element} layer The layer to listen on
 */
FastClick.notNeeded = function(layer) {
	'use strict';
	var metaViewport;
	var chromeVersion;

	// Devices that don't support touch don't need FastClick
	if (typeof window.ontouchstart === 'undefined') {
		return true;
	}

	// Chrome version - zero for other browsers
	chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

	if (chromeVersion) {

		if (deviceIsAndroid) {
			metaViewport = document.querySelector('meta[name=viewport]');

			if (metaViewport) {
				// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
				if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
					return true;
				}
				// Chrome 32 and above with width=device-width or less don't need FastClick
				if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
					return true;
				}
			}

		// Chrome desktop doesn't need FastClick (issue #15)
		} else {
			return true;
		}
	}

	// IE10 with -ms-touch-action: none, which disables double-tap-to-zoom (issue #97)
	if (layer.style.msTouchAction === 'none') {
		return true;
	}

	return false;
};


/**
 * Factory method for creating a FastClick object
 *
 * @param {Element} layer The layer to listen on
 * @param {Object} options The options to override the defaults
 */
FastClick.attach = function(layer, options) {
	'use strict';
	return new FastClick(layer, options);
};


if (true) {

	// AMD. Register as an anonymous module.
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		'use strict';
		return FastClick;
	}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module !== 'undefined' && module.exports) {
	module.exports = FastClick.attach;
	module.exports.FastClick = FastClick;
} else {
	window.FastClick = FastClick;
}


/***/ }),

/***/ 980:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _Rover = __webpack_require__(3);

var _Rover2 = _interopRequireDefault(_Rover);

var _Mustache = __webpack_require__(37);

var _Mustache2 = _interopRequireDefault(_Mustache);

var _gallery_modal = __webpack_require__(406);

var _gallery_modal2 = _interopRequireDefault(_gallery_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializeGalleries() {
  var slides = [];
  var images = (0, _jquery2.default)('.js-shareable-image');
  var template = _Mustache2.default.template('new_design/social/modal_sharing_buttons');

  images.each(function (i, image) {
    var $image = (0, _jquery2.default)(image);

    var shareButtons = template.render({
      imageToShare: $image.attr('data-image-to-share'),
      imageThumbnail: $image.attr('data-image-thumbnail'),
      urlToShare: $image.attr('data-url-to-share'),
      contentType: $image.attr('data-content-type'),
      objectId: $image.attr('data-object-id'),
      campaign: $image.attr('data-campaign'),
      trackingContent: $image.attr('data-tracking-content'),
      caption: $image.attr('data-caption'),
      shareLocation: $image.attr('data-share-location'),
      hideable: $image.attr('data-hideable') === 'true',
      hidden: $image.attr('data-hidden') === 'true'
    });

    var slide = {
      type: 'image',
      src: $image.attr('href'),
      unsafeHtmlCaption: shareButtons
    };

    slides.push(slide);
  });

  var staysGalleryModal = new _gallery_modal2.default({
    classes: 'stays-gallery-modal',
    slides: slides
  });

  images.each(function (i, image) {
    var $image = (0, _jquery2.default)(image);

    (function (val) {
      $image.off('click').on('click', function (e) {
        e.preventDefault();
        if (staysGalleryModal) staysGalleryModal.openTo(val);
      });
    })(i);
  });
}

function init() {
  initializeGalleries();
}

exports.default = {
  init: init,
  initializeGalleries: initializeGalleries
};

/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var showFailure = function showFailure() {
  (0, _jquery2.default)('.js-email-capture-footer-form-failure').fadeIn('fast');
};

var showThanks = function showThanks(response) {
  if (response.status !== 'success') {
    showFailure();
    return;
  }

  (0, _jquery2.default)('.js-email-capture-footer-form-failure').fadeOut('fast');
  (0, _jquery2.default)('.js-email-capture-footer-form-initial').fadeOut('fast', function () {
    (0, _jquery2.default)('.js-email-capture-footer-form-thanks').fadeIn('fast');
  });
};

var initializeEmailCaptureForm = function initializeEmailCaptureForm() {
  (0, _jquery2.default)('.js-email-capture-form').ajaxForm({
    success: showThanks
  });
};

var init = function init() {
  initializeEmailCaptureForm();
};

exports.default = {
  init: init
};

/***/ }),

/***/ 982:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _device = __webpack_require__(96);

var _deeplink = __webpack_require__(586);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _Rover = __webpack_require__(3);

var _Rover2 = _interopRequireDefault(_Rover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  _createClass(_class, null, [{
    key: 'closeBanner',
    value: function closeBanner() {
      (0, _jquery2.default)('.js-app-banner').addClass('hidden');
      (0, _jquery2.default)('body').removeClass('has-banner');
      _jquery2.default.cookie('appBanner', true, { expires: 90 });
    }
  }, {
    key: 'isPossibleBanner',
    value: function isPossibleBanner() {
      if (!_jquery2.default.cookie('appBanner')) {
        return true;
      }
      return false;
    }
  }, {
    key: 'init',
    value: function init() {
      if (!(0, _device.isMobileBrowser)() || !this.isPossibleBanner() || _Rover2.default.utils.isMobileEmbedded() || (0, _jquery2.default)('body').hasClass('no-banner') || !_Rover2.default.context.supportsMobileApp) {
        return;
      }

      var routeURL = (0, _deeplink.getRouteURL)();
      _Rover2.default.context.iOSReviewCount = '2,140+ Reviews';
      _Rover2.default.context.androidReviewCount = '2,300+ Reviews';

      (0, _jquery2.default)('body').addClass('has-banner');
      (0, _jquery2.default)('.js-app-banner').removeClass('hidden');
      (0, _jquery2.default)('.js-app-install-link').attr('href', routeURL);
      (0, _jquery2.default)('.js-close-app-banner').on('click', this.closeBanner);
      if (_Rover2.default.utils.isAndroid()) {
        (0, _jquery2.default)('.js-review-count').text(_Rover2.default.context.androidReviewCount);
      } else {
        (0, _jquery2.default)('.js-review-count').text(_Rover2.default.context.iOSReviewCount);
      }
    }
  }]);

  return _class;
}();

exports.default = _class;

/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _device = __webpack_require__(96);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ZendeskHelp = function () {
  function ZendeskHelp() {
    _classCallCheck(this, ZendeskHelp);
  }

  _createClass(ZendeskHelp, null, [{
    key: 'init',
    value: function init() {
      (0, _jquery2.default)('.js-help-button').on('click', this.onHelpButton.bind(this));
    }
  }, {
    key: 'initZendesk',
    value: function initZendesk() {
      if (!(0, _device.isMobileBrowser)()) {
        window.zEmbed || function (e, t) {
          var n = void 0,
              o = void 0,
              d = void 0,
              i = void 0,
              s = void 0,
              a = [],
              r = document.createElement('iframe');
          window.zEmbed = function () {
            a.push(arguments);
          }, window.zE = window.zE || window.zEmbed, r.src = 'javascript:false', r.title = '', r.role = 'presentation', (r.frameElement || r).style.cssText = 'display: none', d = document.getElementsByTagName('script'), d = d[d.length - 1], d.parentNode.insertBefore(r, d), i = r.contentWindow, s = i.document;

          try {
            o = s;
          } catch (c) {
            n = document.domain, r.src = 'javascript:var d=document.open();d.domain="' + n + '";void(0);', o = s;
          }
          o.open()._l = function () {
            var o = this.createElement('script');
            n && (this.domain = n), o.id = 'js-iframe-async', o.src = e, this.t = +new Date(), this.zendeskHost = t, this.zEQueue = a, this.body.appendChild(o);
          }, o.write('<body onload="document._l();">'), o.close();
        }('//assets.zendesk.com/embeddable_framework/main.js', 'rover.zendesk.com');
      }
    }
  }, {
    key: 'activateDesk',
    value: function activateDesk() {
      if (typeof window.zE.activate === 'function') {
        window.zE.activate();
      } else {
        window.setTimeout(this.activateDesk.bind(this), 500);
      }
    }
  }, {
    key: 'onHelpButton',
    value: function onHelpButton() {
      (0, _jquery2.default)('.js-help-button').hide();
      this.initZendesk();
      this.activateDesk();
    }
  }]);

  return ZendeskHelp;
}();

exports.default = ZendeskHelp;

/***/ })

},[934]);


// WEBPACK FOOTER //
// application_js.03d6fa7deae2e697.js